export const environment = {
  production: true,
  baseUrl: 'https://api.dev.livingmeaningfully.ca',
  googleClientId: '715437575479-r7lovegacbm4r74if42bfub7po120anb.apps.googleusercontent.com',
  facebookClientId: '1128172314362694',
  mailingAddress: 'lm_subscribers_demo@sandbox33c3d16ba71b4904b441ca6bd1f68aa3.mailgun.org',
  socketUrl: 'wss://living-meaningfully.herokuapp.com/ws/connect/?Token:',
  chatSocketUrl: 'wss://api.dev.livingmeaningfully.ca/ws/chat/',
  postSocketUrl: 'wss://api.dev.livingmeaningfully.ca/ws/post/',
  defaultImage: 'https://moonvillageassociation.org/wp-content/uploads/2018/06/default-profile-picture1.jpg',
  stripePrimaryKey: 'pk_test_51L04veJypqg0JOy8Msjmww0zluLSPzUrN4EO5BXjsrEq67rhf6QcgXQIeNi0lD69Udtgp1YNFoYDlziNxfCyyUWL00kfwm4EAs',
};
